import { GoldIcon } from "@components/components";
import React, { useEffect, useRef, useState } from "react";
import { WavyCardProps } from "./wavy-card.props";
import * as S from "./wavy-card.style";

const WavyCard: React.FC<WavyCardProps> = ({
	icon,
	title,
	subtitle,
	index = 0,
}) => {
	const animationDelay = 200;
	const cardRef = useRef<HTMLDivElement>(null);
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const observer = new IntersectionObserver((entries) => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					setTimeout(() => {
						setIsVisible(true);
					}, index * animationDelay);
					observer.unobserve(entry.target);
				}
			}
		});

		if (cardRef.current) {
			observer.observe(cardRef.current);
		}

		return () => {
			if (cardRef.current) {
				observer.unobserve(cardRef.current);
			}
		};
	}, [index]);

	return (
		<S.WavyCardContainer ref={cardRef} className={isVisible ? "visible" : ""}>
			<GoldIcon icon={icon} />
			<S.WavyCardTitle>{title}</S.WavyCardTitle>
			<S.WavyCardSubtitle>{subtitle}</S.WavyCardSubtitle>
		</S.WavyCardContainer>
	);
};

export default WavyCard;
